// extracted by mini-css-extract-plugin
module.exports = {"category-page":"category_category-page__3Zo61","product-grid":"category_product-grid__2bNun"};